import React, { useEffect, useState } from 'react';
import RecipientDetails from '../../../Common/RecipientsDetails/RecipientDetails';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Box, useMediaQuery, useTheme } from '@mui/material';

import CustomSwitch from '../../../Common/Switch/CustomSwitch';
import SwitchwithDetails from '../../../Common/SwitchwithDetails';
import { useDispatch } from 'react-redux';
import {
  addrecipientOtp,
  setLocationWhileSign,
  setPictureWhileSign,
  updateRecipientOtp
} from '../../../../Store/RecipientsSlice.js/RecipientsSlice';

function CKEditorRecipitensInfo({ selRecipient, setShowInfo, getNextColor, getTextNextColor, handleClick }) {
  const isMobile = useMediaQuery('(max-width:768px)');
  const dispatch = useDispatch();
  const [eachPermisson, setEachPermisson] = useState({
    getLocationwhilesigning: false,
    getpicturewhilesiging: false,
    recipientVerification: false
  });

  useEffect(() => {
    if (selRecipient) {
      setEachPermisson({
        recipientVerification: selRecipient.enableOtp ? selRecipient.enableOtp : false,
        getLocationwhilesigning: selRecipient.getLocation ? selRecipient.getLocation : false,
        getpicturewhilesiging: selRecipient.getPicture ? selRecipient.getPicture : false
      });
    }
  }, [selRecipient]);

  const theme = useTheme();
  const handleBackClick = e => {
    e.stopPropagation();
    setShowInfo(false);
  };

  useEffect(() => {
    if (eachPermisson) {
      const payload = {
        enableOtp: eachPermisson.recipientVerification,
        getPicture: eachPermisson.getpicturewhilesiging,
        getLocation: eachPermisson.getLocationwhilesigning
      };
      dispatch(
        updateRecipientOtp({
          ...selRecipient,
          ...payload
        })
      );
      dispatch(addrecipientOtp(eachPermisson.recipientVerification));
      dispatch(setLocationWhileSign(eachPermisson.getLocationwhilesigning));
      dispatch(setPictureWhileSign(eachPermisson.getpicturewhilesiging));
    }
  }, [eachPermisson]);

  return (
    <div>
      <Box display={'flex'} alignItems={'center'} gap={0.6} mt={isMobile ? 1 : 3}>
        <div onClick={handleBackClick} className='pointer-css ck-iconcenteralign'>
          <ChevronLeftIcon sx={{ position: 'relative', fontSize: isMobile ? 22 : 28 }} />
        </div>
        <div className={isMobile ? 'semiBold14' : 'semiBold5'}>Recipients Settings</div>
      </Box>
      <Box mt={isMobile ? 2 : 4} display={'flex'} flexDirection={'column'} rowGap={2}>
        <RecipientDetails
          showRemove
          recipient={selRecipient}
          getNextColor={getNextColor}
          getTextNextColor={getTextNextColor}
          handleClick={handleClick}
        />
      </Box>
      <Box mt={isMobile ? 3 : 6}>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={2}>
          <div className={isMobile ? 'semiBold13' : 'semiBold6'}>Recipient Verification</div>
          <CustomSwitch data={eachPermisson} name={'recipientVerification'} setData={setEachPermisson} />
        </Box>
        <div className={isMobile ? 'medium7' : 'medium4'} style={{ color: '#8E8E8E', marginTop: theme.spacing(2) }}>
          Verify recipient by sending them an OTP on Email Address.
        </div>

        <Box mt={isMobile ? 3 : 5} display={'none'}>
          <div className={isMobile ? 'semiBold13' : 'semiBold6'}>Advance Verification</div>
          <Box mt={isMobile ? 1.5 : 3} display={'flex'} flexDirection={'column'} rowGap={2}>
            <SwitchwithDetails
              subtext={'Get Location while signing'}
              data={eachPermisson}
              name={'getLocationwhilesigning'}
              setData={setEachPermisson}
            />
            <SwitchwithDetails
              subtext={'Get picture of recipient while signing'}
              data={eachPermisson}
              name={'getpicturewhilesiging'}
              setData={setEachPermisson}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default CKEditorRecipitensInfo;
